



































































































































































































































import { Component, Vue } from "vue-property-decorator";
import store from "@/store";
import moment from "moment";

//  @types
import { Incident, OpenIncident } from "@/types/incident";
import { Announcement } from "@/types/Announcement";
//  @components

//  @clients
import AnnouncementClient from "@/Scripts/clients/Announcement-client";
//  @modules
import { getModule } from "vuex-module-decorators";
import SnackbarModule from "@/store/clients/Snackbar.module";
import AnnouncementModule from "@/store/clients/Announcement.module";
import IncidentsModule from "@/store/clients/Incidents.module";
import UserModule from "@/store/clients/User.module";
import AuthModule from "@/store/clients/Auth.module";

const Snackbar = getModule(SnackbarModule, store);
const Announcements = getModule(AnnouncementModule, store);
const Incidents = getModule(IncidentsModule, store);
const User = getModule(UserModule, store);
const Auth = getModule(AuthModule, store);

@Component({
  components: {},
})
export default class AlertsMenu extends Vue {
  // @Data
  isUnreadOnly = true;
  isAnnouncementsLoading = false;
  isAlertsLoading = false;
  mode = "Alerts";
  modeList: string[] = ["Alerts", "Announcements"];
  tab: string | null = "Alerts";
  announcementList: Announcement[] = [];
  alertList: OpenIncident[] = [];
  refreshTimerId: number | null = null;

  //  @Getters
  get isLoggedIn(): boolean {
    return Auth.isLoggedIn;
  }

  get unreadAnnouncementList(): Announcement[] {
    return this.announcementList.filter((item: { isView: boolean }) => item.isView === false);
  }

  get unreadAlertList(): OpenIncident[] {
    return this.alertList.filter((item: OpenIncident) => !item.acknowledged);
  }

  get unreadAnnouncementCount(): number {
    return this.unreadAnnouncementList.length;
  }

  get archivedAnnouncementList(): Announcement[] {
    return this.announcementList.filter((item: { isView: boolean }) => item.isView === true);
  }

  get unreadItemList(): Announcement[] | OpenIncident[] {
    if (this.tab === "Announcements") {
      return this.unreadAnnouncementList;
    } else if (this.tab === "Alerts") {
      return this.unreadAlertList;
    }
    return [];
  }

  get filteredAlertList(): OpenIncident[] {
    if (this.isUnreadOnly) {
      return this.unreadAlertList;
    }
    return this.alertList;
  }

  get filteredAnnouncementList(): Announcement[] {
    if (this.isUnreadOnly) {
      return this.unreadAnnouncementList;
    }
    return this.announcementList;
  }

  get alertListCount(): number {
    return this.alertList.length;
  }

  get userEmail(): string {
    return User.userEmail;
  }

  get userCompanyId(): number | null {
    return User.userCompanyId;
  }

  // @Methods
  close() {
    this.$emit("close");
    setTimeout(() => {
      this.tab = "Alerts"; // Reset to default tab when closing
    }, 100);
  }

  markAll(): void {
    if (this.tab === "Alerts") {
      this.markAllAsAcknowledged();
    } else if (this.tab === "Announcements") {
      this.markAllAsRead();
    }
  }

  async markAsRead(announcementId: number): Promise<void> {
    if (this.userCompanyId === null || this.userCompanyId === undefined) {
      Snackbar.showSnackbar({
        text: "User company ID is not available",
        color: "error",
        timeout: 5000,
      });
      return;
    }
    await AnnouncementClient.readByUser([
      {
        UserEmail: this.userEmail,
        CompanyId: this.userCompanyId as number,
        AnnouncementId: announcementId,
      },
    ]);
    await this.fetchData();
  }

  async markAllAsRead(): Promise<void> {
    if (this.userCompanyId === null || this.userCompanyId === undefined) {
      Snackbar.showSnackbar({
        text: "User company ID is not available",
        color: "error",
        timeout: 5000,
      });
      return;
    }
    if (this.unreadAnnouncementList.length === 0) {
      Snackbar.showSnackbar({
        text: "No unread announcements to mark as read",
        color: "info",
        timeout: 5000,
      });
      return;
    }
    const APIstructureAnnouncementList = this.unreadAnnouncementList.map((item: Announcement) => ({
      UserEmail: this.userEmail,
      CompanyId: this.userCompanyId as number,
      AnnouncementId: item.announcementId,
    }));
    await Announcements.announcementReadByUser(APIstructureAnnouncementList);
    await this.fetchData();
  }

  async markAsAcknowledged(alertId: number): Promise<void> {
    try {
      await AnnouncementClient.AcknowledgeIncident(alertId);
    } catch (error) {
      console.error("Error acknowledging incident:", error);
    }
    await this.fetchData();
  }

  async markAllAsAcknowledged(): Promise<void> {
    if (this.unreadAlertList.length === 0) {
      Snackbar.showSnackbar({
        text: "No unread alerts to acknowledge",
        color: "info",
        timeout: 5000,
      });
      return;
    }
    try {
      await AnnouncementClient.AcknowledgeAllIncidents(this.unreadAlertList);
    } catch (error) {
      Snackbar.showSnackbar({
        text: "Error acknowledging incidents",
        color: "error",
        timeout: 5000,
      });
      console.error("Error acknowledging incidents:", error);
    }
    await this.fetchData();
  }

  redirect(alert: OpenIncident, $event: any): void {
    if ($event.target.closest(".action--mark")) this.markAsRead(alert.id);
    else {
      this.markAsRead(alert.id);
      this.$router.push({ path: "/Notifications", query: { search: alert.vesselName } });
    }
  }

  async fetchData(): Promise<void> {
    try {
      this.isAnnouncementsLoading = true;
      this.isAlertsLoading = true;
      this.announcementList = await Announcements.announcementListByUser();
      this.alertList = await Incidents.getFleetLevelOpenIncidents();
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      this.isAnnouncementsLoading = false;
      this.isAlertsLoading = false;
    }
    this.$root.$emit("announcementlistByUser");
  }

  fromNowDate(timestamp: string): string {
    return moment(timestamp).fromNow();
  }

  //  @Hooks
  async mounted(): Promise<void> {
    await this.fetchData();
  }
}
